<template>
    <rkm-layout-body title="Lista de serviços">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-servico-manutencao-create' })"
                authorize="store-cadastro-servico-manutencao"
                color="primary"
            >
                Cadastrar serviço
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/servico-manutencao/List'

export default {
    components: { List },
}
</script>